import { isProduction } from '@pn/core/utils/env';

let _listener: ((minimum: number) => void) | undefined;

declare global {
  interface Window {
    notifyMinimumBuildNumber?: (minimum: number) => void;
  }
}

export function onMinimumBuildNumber(cb: (minimum: number) => void): void {
  _listener = cb;
}

export function notifyMinimumBuildNumber(minimum: number): void {
  _listener?.(minimum);
}

if (typeof window !== 'undefined' && !isProduction()) {
  window.notifyMinimumBuildNumber = notifyMinimumBuildNumber;
}
